module.exports = __webpack_public_path__ + "img/km1-sans-sac.f7487a30.jpg";